import classNames from 'classnames';
import React from 'react';
import { Button, ButtonSize, ButtonVariant } from '../../../Components/Button';
import { DecisionSupportDangerIcon, DecisionSupportSuccessIcon, DecisionSupportWarningIcon } from '../../../Components/Icons';
import { DecisionSupportStatus } from '../../../Contracts/MedicationModels';
import { dangerVariant, iconLight, success, successGlowBorder, warningGlowBorder, white } from '../../../Styles/Colours';
import styles from './DecisionAlertBar.module.css';
export var DecisionAlertBarTypes;
(function (DecisionAlertBarTypes) {
    DecisionAlertBarTypes[DecisionAlertBarTypes["Ok"] = 0] = "Ok";
    DecisionAlertBarTypes[DecisionAlertBarTypes["Error"] = 1] = "Error";
    DecisionAlertBarTypes[DecisionAlertBarTypes["Warning"] = 2] = "Warning";
})(DecisionAlertBarTypes || (DecisionAlertBarTypes = {}));
function getDecisionSupportStyle(decisionSupportInformation) {
    var status = decisionSupportInformation.decisionSupportDetail.status;
    var containerStyle = styles.default;
    var icon = DecisionSupportSuccessIcon;
    var iconColour = successGlowBorder;
    var iconBackgroundColour = success;
    var buttonVariant = ButtonVariant.primary;
    // TODO: This will eventually be driven by more information, for now it's just static text..
    var titleText = 'Alert and notification(s) found';
    var bodyText = '';
    if (status === DecisionSupportStatus.Warning) {
        containerStyle = styles.warning;
        icon = DecisionSupportWarningIcon;
        iconColour = white;
        iconBackgroundColour = warningGlowBorder;
        buttonVariant = ButtonVariant.warning;
        titleText = 'Alert and notification(s) found';
        bodyText = 'Review and note alerts found for this medication';
    }
    else if (status === DecisionSupportStatus.Error) {
        containerStyle = styles.error;
        icon = DecisionSupportDangerIcon;
        iconColour = white;
        iconBackgroundColour = iconLight;
        buttonVariant = null;
        titleText = 'Error establishing a connection';
        bodyText = 'Please wait while we try to reconnect in the background.';
    }
    else if (status === DecisionSupportStatus.Alert) {
        containerStyle = styles.danger;
        icon = DecisionSupportDangerIcon;
        iconColour = white;
        iconBackgroundColour = dangerVariant;
        buttonVariant = ButtonVariant.danger;
        titleText = 'Alert and notification(s) found';
        bodyText = 'Review and note alerts found for this medication';
    }
    return {
        containerStyle: containerStyle,
        icon: icon,
        iconColour: iconColour,
        iconBackgroundColour: iconBackgroundColour,
        buttonVariant: buttonVariant,
        titleText: titleText,
        bodyText: bodyText
    };
}
export function DecisionAlertBar(props) {
    var bannerStyles = getDecisionSupportStyle(props.decisionSupportInformation);
    var Icon = bannerStyles.icon;
    return (React.createElement("div", { className: classNames(styles.container, bannerStyles.containerStyle) },
        React.createElement("div", { className: styles.icon },
            React.createElement(Icon, { size: '32', backgroundColour: bannerStyles.iconBackgroundColour, color: bannerStyles.iconColour, noCircularContainer: true, noPadding: true })),
        React.createElement("div", { className: styles.information },
            React.createElement("div", { className: styles.title }, bannerStyles.titleText),
            bannerStyles.bodyText && React.createElement("div", { className: styles.body }, bannerStyles.bodyText)),
        bannerStyles.buttonVariant && (React.createElement("div", { className: styles.buttonContainer },
            React.createElement(Button, { onClick: props.showDecisionSupportWizard, width: 133, variant: bannerStyles.buttonVariant, size: ButtonSize.small, testId: 'review-alerts' }, "Review alerts")))));
}
